import wrapperFunctional from './index.function';
import DashboardHeader from '../DashboardHeader';
import Sidebar from '../Sidebar';
import { cn } from '../../utils/utils';

const Wrapper = ({ isSideBar = true, children, isPublic, isCenter = false }) => {
  const { dashboard_key } = wrapperFunctional(isPublic);

  return (
    <div key={dashboard_key} className='bg-sky-blue min-h-screen flex flex-col gap-6'>
      <DashboardHeader />
      <div className={cn('mt-[88px] flex flex-col w-full h-full flex-1', isCenter ? 'justify-center items-center bg-white' : '')}>
        {isSideBar ? <Sidebar>{children}</Sidebar> : <div className={`bg-white p-4 md:p-8 w-full`}>{children}</div>}
      </div>
    </div>
  );
};

export default Wrapper;
